<template lang="html">
    <div class="row">
        <div
            v-for="(item, idx) in categories"
            :key="idx"
            class="col-6 col-sm-4 col-md-3 col-lg-2 my-3"
        >
            <router-link :to="'/categoria/' + item.ref" class="link">
                <CardCategory :title="item.title" :imageURL="baseUrlStorage+item.imageURL" />
            </router-link>
        </div>
    </div>
</template>
<script>
import CardCategory from './CardCategory.vue'
import { mapState } from "vuex";
export default {
    inject: ['baseUrlStorage'],
    data() {
        return {
            categories1: [
                {
                    title: "Administrativo",
                    imageURL: "https://i.ibb.co/ZLgNgWp/Card-Category-bbff0ef1.png",
                    ref: "Administrativo"
                },
                {
                    title: "Ambiental",
                    imageURL: "https://i.ibb.co/68rWSz2/Card-Category2.png",
                    ref: "Ambiental"
                },
                {
                    title: "Arbitraje",
                    imageURL: "https://i.ibb.co/ZLgNgWp/Card-Category-bbff0ef1.png",
                    ref: "Arbitraje"
                },
                {
                    title: "Civil",
                    imageURL: "https://i.ibb.co/68rWSz2/Card-Category2.png",
                    ref: "Civil"
                },
                {
                    title: "Consumidor",
                    imageURL: "https://i.ibb.co/ZLgNgWp/Card-Category-bbff0ef1.png",
                    ref: "Consumidor"
                },
                {
                    title: "Constitucional",
                    imageURL: "https://i.ibb.co/68rWSz2/Card-Category2.png",
                    ref: "Constitucional"
                },
                {
                    title: "Derechos Humanos",
                    imageURL: "https://i.ibb.co/ZLgNgWp/Card-Category-bbff0ef1.png",
                    ref: "Derechos Humanos"
                },
                {
                    title: "Laboral",
                    imageURL: "https://i.ibb.co/68rWSz2/Card-Category2.png",
                    ref: "Laboral"
                },
                {
                    title: "Mercantil y sociedades",
                    imageURL: "https://i.ibb.co/ZLgNgWp/Card-Category-bbff0ef1.png",
                    ref: "Mercantil y Sociedades"
                },
                {
                    title: "Penal",
                    imageURL: "https://i.ibb.co/68rWSz2/Card-Category2.png",
                    ref: "Penal"
                },
                {
                    title: "Procesal",
                    imageURL: "https://i.ibb.co/ZLgNgWp/Card-Category-bbff0ef1.png",
                    ref: "Procesal"
                },
                {
                    title: "Tributario",
                    imageURL: "https://i.ibb.co/68rWSz2/Card-Category2.png",
                    ref: "Tributario"
                }
            ]
        }
    },
    components: {
        CardCategory
    },
    computed:{
         ...mapState({
        'categories': state => state.data.categories
      }),
    }
}
</script>
<style lang="css" scoped>
.link {
    text-decoration: none;
}
</style>